import { useFormikContext } from 'formik';
import isObject from 'lodash/isObject';
import { useEffect, useRef } from 'react';

const getFirstErrorKey = (object, keys = []) => {
  const firstErrorKey = Object.keys(object)[0];
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
  }
  return [...keys, firstErrorKey].join('.');
};

/**
 * @param {{
 *   children: any,
 *   onInvalidSubmit?: (errors: any, values: any) => void,
 * }} props
 */
const FormikOnError = ({ children, onInvalidSubmit }) => {
  const formik = useFormikContext();
  const lastReportedSubmitCount = useRef(0);

  useEffect(() => {
    if (!formik.isValid && formik.submitCount > 0) {
      const firstErrorKey = getFirstErrorKey(formik.errors);
      if (global.window.document.getElementsByName(firstErrorKey).length) {
        global.window.document.getElementsByName(firstErrorKey)[0].focus();
      }

      if (lastReportedSubmitCount.current !== formik.submitCount) {
        lastReportedSubmitCount.current = formik.submitCount;
        onInvalidSubmit?.(formik.errors, formik.values);
      }
    }
  }, [
    formik.errors,
    formik.isValid,
    formik.submitCount,
    formik.values,
    onInvalidSubmit,
  ]);
  return children;
};

export default FormikOnError;
